import { render, staticRenderFns } from "./ExpressManage.vue?vue&type=template&id=10cfaf09"
import script from "./ExpressManage.vue?vue&type=script&lang=ts"
export * from "./ExpressManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports